import { useState } from "react";
import Accordion from "./Accordion";
import { cardInfos } from "../../components/Data/datas";

const Curriculum = ({ curriculumId }) => {
  const [toggle, setToggle] = useState(0);
  const [open, setOpen] = useState(false);

  function handleToggle(id) {
    let handler = cardInfos
      .filter((cardInfo) => cardInfo.curriculums.id === id)
      .map((cardInfo) => (cardInfo.curriculums.show === open ? true : false));
    setOpen(handler[0]);
    setToggle(id);
  }

  return (
    <div className="my-10">
      <div className="space-y-1 px-2">
        {cardInfos
          .filter((cardInfo) => cardInfo.id === curriculumId)
          .map((cardInfo) => (
            <Accordion
              key={cardInfo.curriculums.id}
              onClick={() => handleToggle(cardInfo.curriculums.id)}
              {...cardInfo.curriculums}
              compare={toggle !== cardInfo.curriculums.id}
              open={open}
            />
          ))}
      </div>
    </div>
  );
};

export default Curriculum
